import { studentRequests } from "api/studentApi";
import { useEffect } from "react";
import { ReferenceInput } from "react-admin";
import { useFormContext, useWatch } from "react-hook-form";
import AutoPickSelectInput from "server/components/Fields/AutoPickSelectInput";

const DisciplineSelectInput = ({ defVal, readOnly }) => {
  const curriculumId = useWatch({ name: "curriculumId" });
  const academicYearSessionId = useWatch({ name: "academicYearSessionId" });
  const { setValue } = useFormContext();

  useEffect(() => {
    setValue("disciplineId", null);
  }, [academicYearSessionId, setValue]);

  useEffect(() => {
    if (defVal) {
      setValue("disciplineId", defVal, { shouldDirty: false });
    }
  }, [defVal, setValue]);

  return (
    <ReferenceInput
      key={academicYearSessionId}
      source="disciplineId"
      reference={studentRequests.getCurriculumDisciplinesSelect(curriculumId)}
      filter={{ academicSessionId: academicYearSessionId }}
    >
      <AutoPickSelectInput
        source="disciplineId"
        label="Дисциплина"
        optionText="name"
        filterToQuery={q => (q?.length > 2 ? { disciplineName: q } : {})}
        fullWidth
        isRequired
        emptyText={false}
        readOnly={readOnly}
      />
    </ReferenceInput>
  );
};

export default DisciplineSelectInput;
